import React from "react";
import config from "../config.json";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { Button } from "@mui/material";
import CustomAliceCarousel from "./customAliceCarousel";
import "react-alice-carousel/lib/alice-carousel.css";

export const VerticalTimelineTemplate = ({ dataArray, userData }) => {

  function handleReadMore(p) {
    if (userData.show) {
      return (window.location.href = `/event/${p.EventId}`);
    } else {
      return (window.location.href = `/program/${p.ProgramId}`);
    }
  }


  return (
    <>
      <VerticalTimeline
        lineColor={config[process.env.REACT_APP_HOST_NAME].css.websiteColor}
      >
        {dataArray.map((p) => (
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: "rgb(239, 239, 239)", color: "#000" }}
            contentArrowStyle={{
              borderRight: `7px solid  ${config[process.env.REACT_APP_HOST_NAME].css.websiteColor
                }`,
            }}
            date={p.StartDate}
            key={p.EventId}
            iconStyle={{
              background:
                config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
              color: "#fff",
            }}
          >

            <CustomAliceCarousel images={p.image ? p.image : p.imageUrl} autoPlayInterval={2000} />

            <div
              style={{
                borderBottom: "4px solid",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor:
                  config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
                color: "white",
                borderColor:
                  config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
              }}
            >
              <div style={{ paddingLeft: "10px", fontSize: "20px" }}>
                {p.EventName ? p.EventName : p.ProgramName}
              </div>
            </div>
            <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
              {p.EventDescription ? p.EventDescription : p.ProgramDescription}
            </div>
            <div style={{ paddingTop: "10px" }}>
              <Button
                style={{
                  height: 30,
                  fontFamily: "Raleway",
                  width: "40%",
                  backgroundColor:
                    config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                  borderRadius: 30,
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                }}
                onClick={() => { handleReadMore(p) }}
              >
                Read More
              </Button>
            </div>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </>
  );
};
